module.exports = __webpack_public_path__ + "assets/img/stats.86ca3f05.jpg";